import { safeMarkDevFlag } from '@psl/utils/safeMarkDevFlag';
import { lazy } from 'react';
import { isMobileLayout } from '../../components/styles/responsive';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import type { ProfilePageProps } from './types';

const kForceBottomSheet = safeMarkDevFlag(false);

const ProfilePageContentWrapper = lazy(
  () => import('./ProfilePageContentWrapper'),
);

const ProfilePage = wrapLazyNavigatorScreen(
  (props: ProfilePageProps) => {
    return <ProfilePageContentWrapper {...props} />;
  },
  ({ route }) =>
    route.params.mobilePresentation === 'bottomSheet' ||
    kForceBottomSheet ||
    !isMobileLayout()
      ? {
          // important to keep compatible w/ other screen presented in modal style
          presentation: 'transparentModal',
          cardOverlayEnabled: true,
          animationEnabled: false,
          detachPreviousScreen: false,
          cardStyle: {
            backgroundColor: 'transparent',
          },
          headerShown: false,
        }
      : {
          headerShown: false,
        },
);

export default ProfilePage;
